<template>
  <div :class="{ 'language-selector': true, 'language-selector--open': this.isActive }" ref="languageSelector" @click="toggleList">
    <i class="icon icon--globe"></i>

    <button>{{ languageTrim(currentLanguage) }}</button>

    <ul>
      <li>
        <a @click="setCurrentLanguage('en')">English</a>
      </li>

      <li>
        <a @click="setCurrentLanguage('es')">Español</a>
      </li>

      <li>
        <a @click="setCurrentLanguage('pt_BR')">Português</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",
  data() {
    return {
      isActive: false
    };
  },
  created() {
    this.closeLanguageSelector();
  },
  methods: {
    setCurrentLanguage(language) {
      this.$store.dispatch("language/changeCurrentLanguage", language);
      this.$i18n.locale = language;
    },

    toggleList() {
      this.$data.isActive = !this.$data.isActive;
    },

    languageTrim(code) {
      switch (code) {
        case "pt_BR":
          return "Português";
        case "es":
          return "Español";
        default:
          return "English";
      }
    },

    closeLanguageSelector() {
      document.body.addEventListener("click", e => {
        const { target } = e;

        if (!target.parentElement.classList.contains("language-selector")) this.$data.isActive = false;
        else this.$data.isActive = true;
      });

      document.body.addEventListener("keyup", e => {
        const code = e.keyCode || e.which;

        if (code === 27 && document.querySelector(".language-selector--open")) this.$data.isActive = false;
      });
    }
  },
  computed: {
    currentLanguage() {
      return this.$store.getters["language/currentLanguage"];
    }
  }
};
</script>
